import { ethStakeAccountState } from '@exodus/ethereum-lib'
import { asset } from '@exodus/ethereumholesky-meta'

export const stakingConfiguration = {
  ethereumholesky: { accountStateExtraData: ethStakeAccountState(asset) },
}
